import { useEffect, useMemo } from "react";
import { sessionAssignationContextKey, sessionAssignationStore } from "@context/sessionAssignation";
import type { SessionAssignationContext } from "@services/types/session-assignation";
import { useSessionAssignationLoad } from "@services/collections/session-assignation";

/** Loads the current route after discarding a different assignment context. */
export const useSessionAssignationInitialization = ({
  scenarioId,
  originId,
  linkId,
}: SessionAssignationContext) => {
  const context = useMemo(() => ({ scenarioId, originId, linkId }), [scenarioId, originId, linkId]);
  const load = useSessionAssignationLoad(context);
  useEffect(() => {
    const current = sessionAssignationStore.getState();
    if (
      current.context &&
      sessionAssignationContextKey(current.context) !== sessionAssignationContextKey(context)
    )
      current.reset();
    const after = sessionAssignationStore.getState();
    if (!after.context || ["idle", "load-error"].includes(after.phase)) void load();
  }, [load, context]);
  return load;
};
